import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FrustratingReasons = lazyWithPreload(
  () => import('./FrustratingReasons'),
)
